import React, { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Music, Trash2, Upload } from "lucide-react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function TotemMusicPanel() {
  const [music, setMusic] = useState(null);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  useEffect(() => {
    api.get("/totem/music/info").then((r) => setMusic(r.data?.music || null)).catch(() => {});
  }, []);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 15 * 1024 * 1024) { toast.error("File troppo grande (max 15 MB)"); return; }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const r = await api.post("/totem/music", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setMusic(r.data?.music || null);
      toast.success("Brano caricato: suonerà quando l'obiettivo è raggiunto");
    } catch (e) {
      toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Caricamento non riuscito");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  const remove = async () => {
    setBusy(true);
    try { await api.delete("/totem/music"); setMusic(null); toast.success("Brano rimosso: torna il ritmo disco"); }
    catch { toast.error("Rimozione non riuscita"); }
    finally { setBusy(false); }
  };

  return (
    <div className="col-span-2 rounded-sm border border-slate-200 bg-white p-3" data-testid="totem-music-panel">
      <div className="flex items-center gap-2 text-sm font-bold text-slate-800"><Music className="h-4 w-4 text-[#0052FF]" /> Musica dei ballerini</div>
      <div className="mt-1 text-[11px] text-slate-500">
        Quando l'obiettivo di gruppo è raggiunto, i ballerini fanno le mosse YMCA a tempo. Senza un brano caricato suona un ritmo disco creato dall'app.
        Puoi caricare un tuo file audio (MP3, M4A, WAV, OGG · max 15 MB) di cui hai i diritti d'uso.
      </div>
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <span className="text-xs font-semibold text-slate-700" data-testid="totem-music-current">
          {music ? `Brano: ${music.filename}` : "In uso: ritmo disco dell'app"}
        </span>
        <input ref={inputRef} type="file" accept="audio/*" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="totem-music-file-input" />
        <Button type="button" size="sm" variant="outline" className="ml-auto rounded-sm" disabled={busy} onClick={() => inputRef.current?.click()} data-testid="totem-music-upload-btn">
          <Upload className="mr-1 h-3.5 w-3.5" /> {busy ? "Attendi..." : music ? "Sostituisci brano" : "Carica brano"}
        </Button>
        {music && (
          <Button type="button" size="sm" variant="outline" className="rounded-sm text-red-600" disabled={busy} onClick={remove} data-testid="totem-music-remove-btn">
            <Trash2 className="mr-1 h-3.5 w-3.5" /> Rimuovi
          </Button>
        )}
      </div>
    </div>
  );
}
